import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import { Loader } from '@components';
import { businessesQuery } from '@queries';

const Business = ({ business }) => {
  return (
    <div className="sb-sidebar-search-item">
      <div>
        <Link
          to={`/dashboard/projects/${business.id}`}
          title={business.business_name}
        >
          {business.business_name}
        </Link>
      </div>
    </div>
  );
};

export const SearchProjects = ({ searchTerm }) => {
  // Fetch businesss
  const {
    data: businessesData,
    isPending: businessesIsPending,
    isError,
  } = useQuery(
    businessesQuery({
      q: searchTerm,
      deleted: 0,
      limit: 3,
      order_by: 'business_name',
    }),
  );

  return (
    <>
      {businessesIsPending && (
        <Loader className="sb-loader sb-loader-sidebar-search" />
      )}
      {!businessesIsPending && businessesData.objects.length > 0 && (
        <>
          <h2>Projects</h2>
          <div className="sb-sidebar-search-row">
            {businessesData.objects.map((business) => {
              return <Business key={business.id} business={business} />;
            })}
          </div>
        </>
      )}
    </>
  );
};
